import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { MembershipService } from '../../../services/membership/membership.service';
import { AuthService } from '../../../services/auth';

@Component({
  selector: 'app-membership-expired',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div class="max-w-md w-full space-y-8">
        <div class="text-center">
          <!-- Icon -->
          <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 dark:bg-red-900/20">
            <svg class="h-10 w-10 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
          </div>
          
          <!-- Title -->
          <h2 class="mt-6 text-3xl font-bold text-gray-900 dark:text-white">
            Período de Prueba Expirado
          </h2>
          
          <!-- Description -->
          <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Tu período de prueba gratuito de 7 días ha expirado. Para continuar usando CitaLink Pro, necesitas suscribirte a uno de nuestros planes.
          </p>
        </div>

        <!-- Membership Info -->
        <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4">
            Información de tu Membresía
          </h3>
          
          <div class="space-y-3">
            <div class="flex justify-between">
              <span class="text-sm text-gray-500 dark:text-gray-400">Plan:</span>
              <span class="text-sm font-medium text-gray-900 dark:text-white">
                {{ (membershipStatus$ | async)?.planName || 'Professional' }}
              </span>
            </div>
            
            <div class="flex justify-between">
              <span class="text-sm text-gray-500 dark:text-gray-400">Estado:</span>
              <span class="text-sm font-medium text-red-600 dark:text-red-400">
                Expirado
              </span>
            </div>
            
            @if((membershipStatus$ | async)?.trialEndDate) {
              <div class="flex justify-between">
                <span class="text-sm text-gray-500 dark:text-gray-400">Fecha de expiración:</span>
                <span class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ (membershipStatus$ | async)?.trialEndDate | date:'dd/MM/yyyy' }}
                </span>
              </div>
            }
          </div>
        </div>

        <!-- Plan Information -->
        <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4">
            Plan Professional
          </h3>
          
          <div class="space-y-3">
            <div class="flex justify-between">
              <span class="text-sm text-gray-500 dark:text-gray-400">Precio mensual:</span>
              <span class="text-sm font-medium text-gray-900 dark:text-white">
                $50,000 COP
              </span>
            </div>
            
            <div class="flex justify-between">
              <span class="text-sm text-gray-500 dark:text-gray-400">Precio anual:</span>
              <span class="text-sm font-medium text-gray-900 dark:text-white">
                $510,000 COP
                <span class="text-xs text-green-600 dark:text-green-400">(15% descuento)</span>
              </span>
            </div>
          </div>
          
          <ul class="mt-4 space-y-2 text-sm text-gray-600 dark:text-gray-400">
            <li class="flex items-center">
              <svg class="h-4 w-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
              Agendas ilimitadas
            </li>
            <li class="flex items-center">
              <svg class="h-4 w-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
              Recordatorios por WhatsApp
            </li>
            <li class="flex items-center">
              <svg class="h-4 w-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
              Múltiples profesionales
            </li>
            <li class="flex items-center">
              <svg class="h-4 w-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
              Reportes y exportación
            </li>
          </ul>
        </div>

        <!-- Action Buttons -->
        <div class="space-y-3">
          <button 
            (click)="goToMembership()"
            class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-500 hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 transition-colors">
            Suscribirse Ahora
          </button>
          
          <button 
            (click)="logout()"
            class="w-full flex justify-center py-3 px-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 transition-colors">
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class MembershipExpiredComponent {
  private router = inject(Router);
  private membershipService = inject(MembershipService);
  private authService = inject(AuthService);

  membershipStatus$ = this.membershipService.membershipStatus$;

  goToMembership(): void {
    this.router.navigate(['/settings/billing']);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth/signin']);
  }
}
